import React, {useCallback, useState} from 'react';
import Grid from "@mui/material/Grid";
import CustomSelect from "../../../widgets/inputs/CustomSelect";
import {valueRegister} from "../../../../utils/RegisterUtils";
import {Button, MenuItem, TextField} from "@mui/material";
import CustomDateInput from "../../../widgets/inputs/CustomDateInput";
import CustomText from "../../../widgets/inputs/CustomText";
import { Autocomplete } from '@mui/material';
import {useFormContext} from "react-hook-form";
import {PaperComponent} from "../../../../styles/components/DynamicComponentStyle";

export const AgendaForm = ({fasce}) => {
	const [tags, setTags] = useState([]);
	const {control, watch, setValue, errors} = useFormContext();

	const handleCreateTag = event => {
		switch (event.key) {
			case ",":
			case "Enter":
			case "\n":
			case "\t":
			case "Alt":
			case "Tab":
			case " ": {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.value.length > 0) {
					setTags([...tags, event.target.value?.toUpperCase()]);
				}
				break;
			}
			default:
		}
	};

	const setAllTag = useCallback(() => {
		for (let i = 0; i <= fasce.length; i++) {
			setValue(("fascia" + i + "Tag"), tags.join(","))
		}
	}, [setValue, tags, fasce])

	const riempiPosti = useCallback(() => {
		let postiTot = watch("postiI");
		let postoPerFascia = Math.floor(postiTot / fasce.length);
		let rimanenti = postiTot - (postoPerFascia * fasce.length);
		console.log(postiTot, postoPerFascia, rimanenti);
		for (let i = 0; i <= fasce.length; i++) {
			if (rimanenti > 0) {
				setValue(("fascia" + (i + 1) + "I"), (postoPerFascia + 1).toString())
				rimanenti -= 1;
			} else {
				setValue(("fascia" + (i + 1) + "I"), postoPerFascia.toString())
			}
		}
	}, [fasce, watch, setValue])

	return (
		<React.Fragment>
			<Grid container spacing={3}>
				<Grid item xs={12} sm={4}>
					<CustomSelect
						control={control}
						rules={valueRegister}
						name={"luogo"}
						label={"Luogo prenotazione"}
						autoFocus={true}
						none={true}
						defaultValue={""}
						noneValue={""}
						error={errors["luogo"]}
					>
						<MenuItem value={"Via plava 151"}>
							Via plava 151
						</MenuItem>
						<MenuItem value={"Via le chiuse 66"}>
							Via le chiuse 66
						</MenuItem>
						<MenuItem value={"Via del Ridotto 9"}>
							Via del Ridotto 9
						</MenuItem>
						<MenuItem value={"Domicilio"}>
							Domicilio
						</MenuItem>
						<MenuItem value={"Alberghi"}>
							Alberghi
						</MenuItem>
					</CustomSelect>
				</Grid>
				<Grid item xs={12} sm={2}>
					<CustomSelect
						control={control}
						rules={valueRegister}
						name={"enable"}
						label={"Abilita"}
						defaultValue={"true"}
						error={errors["enable"]}
					>
						<MenuItem value={"true"}>
							Sì
						</MenuItem>
						<MenuItem value={"false"}>
							No
						</MenuItem>
					</CustomSelect>
				</Grid>
				<Grid item xs={12} sm={4}>
					<CustomDateInput
						label={"Data"}
						control={control}
						defaultValue={null}
						rules={{required: true}}
						name={"data"}
						error={errors["data"]}
					/>
				</Grid>
				<Grid item xs={12} sm={2}>
					<CustomText
						control={control}
						rules={{required: true}}
						name={"postiI"}
						label={"Posti iniziali"}
						autoFocus={false}
						type={"number"}
						error={errors["postiI"]}
					/>
				</Grid>
				<Grid item xs={12}>
					<CustomSelect
						control={control}
						rules={valueRegister}
						name={"tipo"}
						label={"Tipologia agenda"}
						defaultValue={"molecolare"}
						error={errors["tipo"]}
					>
						<MenuItem value={"molecolare"}>
							Agenda per tamponi molecolari
						</MenuItem>
						<MenuItem value={"rapido"}>
							Agenda per tamponi rapidi
						</MenuItem>
					</CustomSelect>
				</Grid>

				<Grid item xs={12} sm={6}>
					<Autocomplete
						multiple
						freeSolo
						options={[]}
						PaperComponent={PaperComponent}
						getOptionLabel={option => option || option}
						value={tags}
						onChange={(event, newValue) => setTags(newValue)}
						filterSelectedOptions
						renderInput={params => {
							params.inputProps.onKeyDown = handleCreateTag;
							return (
								<TextField
									{...params}
									variant="outlined"
									label="TAG"
									fullWidth
								/>
							);
						}}
					/>
				</Grid>
				<Grid item xs={12} sm={3}>
					<Button fullWidth style={{height: "100%", borderRadius: 24}} onClick={setAllTag}>
						Rimepi tag
					</Button>
				</Grid>
				<Grid item xs={12} sm={3}>
					<Button fullWidth style={{height: "100%", borderRadius: 24}} onClick={riempiPosti}>
						Riempi posti
					</Button>
				</Grid>

				{
					fasce.map((fascia, index) => {
						return (
							<Grid item xs={12} sm={6} key={index}>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={5}>
										<CustomText
											control={control}
											rules={{required: false}}
											name={"fascia" + (index + 1) + "I"}
											label={(index + 8) + fascia + " - " + (index + 9) + fascia}
											autoFocus={false}
											type={"text"}
											error={errors["fascia" + (index + 1) + "I"]}
										/>
									</Grid>
									<Grid item xs={12} sm={7}>
										<CustomText
											control={control}
											rules={{required: false}}
											name={"fascia" + (index + 1) + "Tag"}
											label={"Tag"}
											autoFocus={false}
											type={"text"}
											error={errors["fascia" + (index + 1) + "Tag"]}
										/>
									</Grid>
								</Grid>
							</Grid>
						)
					})
				}

			</Grid>
		</React.Fragment>
	);
};
